import { render, staticRenderFns } from "./header.html?vue&type=template&id=f8c2e130&scoped=true&"
import script from "./header.js?vue&type=script&lang=js&"
export * from "./header.js?vue&type=script&lang=js&"
import style0 from "./header.scss?vue&type=style&index=0&id=f8c2e130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c2e130",
  null
  
)

export default component.exports